<template>
  <DialogLayout
    title="新規追加"
    :visible.sync="dialogVisible"
    width="65em"
    @open="open"
  >
    <template #form>
      <UserMasterForm
        ref="userForm"
        v-model="userFormModel"
        label-width="10em"
        formMode="register"
        :autocomplete-user-id-set="autocompleteUserIdSet"
        :autocomplete-user-name-set="autocompleteUserNameSet"
      />
    </template>
    <template #footer>
      <RegisterDialogFooter
        @clear="clickClear"
        @register="clickRegister"
      />
    </template>
 </DialogLayout>
</template>

<script>
import DialogLayout from '@/components/templates/DialogLayout.vue'
import UserMasterForm from '@/components/organisms/dialog/master/UserMasterForm.vue'
import RegisterDialogFooter from '@/components/organisms/dialog/RegisterDialogFooter.vue'
import UserAutocompleteLoader from '@/mixins/UserAutocompleteLoader.vue'

export default {
  components: {
    DialogLayout,
    UserMasterForm,
    RegisterDialogFooter
  },
  mixins: [
    UserAutocompleteLoader
  ],
  props: {
    autocompleteUserIdSet: {
      type: Array,
      default: () => ([])
    },
    autocompleteUserNameSet: {
      type: Array,
      default: () => ([])
    },
    currentRow: {
      type: Object,
      default: () => {
        return {}
      }
    },
    visible: Boolean
  },
  data () {
    return {
      userFormModel: {
        user_id: undefined,
        user_name: undefined,
        customer_code: undefined,
        phone_number: undefined,
        email: undefined,
        role_id: undefined,
        // login_user_id: undefined,
        password: undefined
      }
    }
  },
  computed: {
    dialogVisible: {
      get () {
        return this.visible
      },
      set (visible) {
        this.$emit('update:visible', visible)
      }
    }
  },
  mounted () {
  },
  methods: {
    clickClear () {
      this.$refs.userForm.clearFields()
    },
    async clickRegister () {
      this.$loadingMask.on()

      // this.userFormModel.login_user_id = this.$loginuser.get('username')
      // this.userFormModel.password = 'P@ssw0rd'
      // this.userFormModel.password = this.getTemporaryPassword()
      // this.userFormModel.role_id = 'admin'
      // const params = { ...this.userFormModel }

      this.$refs.userForm.validate()
        .then((valid) => {
          // return this.$axios.post('/user', params)
          return this.$axios.post('/user', this.userFormModel)
        })
        .then((res) => {
          this.$fcMessage.showMessage(res.data.message)
          this.dialogVisible = false
          // this.margeUserIdSet(this.userFormModel.user_id)
          // this.margeUserNameSet(this.userFormModel.user_name)
          this.$emit('refresh')
        })
        .catch((e) => {
          if (e.response) {
            switch (e.response.status) {
              case 402:
                this.$fcMessage.showMessage(e.response.data.message)
                break
              default:
            }
          }
        })
        .finally(() => {
          this.$loadingMask.off()
        })
    },
    open () {
      const trimItem = ['user_id', 'user_name']
      this.$nextTick(() => {
        this.$refs.userForm.clearFields()
        Object.keys(this.userFormModel)
          .forEach((x) => {
            if (trimItem.includes(x) && this.currentRow[x]) {
              this.currentRow[x] = this.currentRow[x].trimEnd()
            }
            this.$set(this.userFormModel, x, this.currentRow[x])
          })
      })
    }
  }
}
</script>

<style lang="scss">
</style>
